module.exports = __webpack_public_path__ + "img/iconDropDownBlock.4e13ba96.svg";